import { render, staticRenderFns } from "./demo-block.vue?vue&type=template&id=fa7d61fc&scoped=true&"
import script from "./demo-block.vue?vue&type=script&lang=js&"
export * from "./demo-block.vue?vue&type=script&lang=js&"
import style0 from "./demo-block.vue?vue&type=style&index=0&id=fa7d61fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7d61fc",
  null
  
)

export default component.exports